export class LocalBusinessesQuery {
  constructor () {
    this.limit = undefined;
    this.pageNumber = undefined;
    this.text = undefined;
  }

  static get KEYS () {
    return {
      LOCAL_BUSINESS_ID: 'localBusinessId',
      APPLICATION_CODE: 'applicationCode'
    };
  }
}
